import React, { useState, useEffect } from 'react';
import { Drawer } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';

import './index.less';
import { MAIN_CLASS_NAME, RESIZE_BAR_CLASS_NAME } from './const';

const DEFAULT_MIN_WIDTH = 256;
const DEFAULT_MAX_WIDTH = 2048;

const MOUSE_MOVE_EVENT_NAME = 'mousemove';
const MOUSE_UP_EVENT_NAME = 'mouseup';

interface IResizableDrawerProps extends DrawerProps {
  resizable?: boolean;
  minWidth?: number | string;
  maxWidth?: number | string;
}

const ResizableDrawer: React.FC<IResizableDrawerProps> = ({
  resizable,
  minWidth = DEFAULT_MIN_WIDTH,
  maxWidth = DEFAULT_MAX_WIDTH,
  children,
  ...props
}) => {
  const [isResizing, setIsResizing] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState<number | string>();

  useEffect(() => {
    setDrawerWidth(props.width);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);

  useEffect(() => {
    if (!isResizing) return;

    const handleMouseMove = (e: MouseEvent) => {
      const offsetRight = document.body.offsetWidth - (e.clientX - document.body.offsetLeft);

      if (offsetRight > +minWidth && offsetRight < +maxWidth) {
        setDrawerWidth(offsetRight);
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    document.addEventListener(MOUSE_MOVE_EVENT_NAME, handleMouseMove);
    document.addEventListener(MOUSE_UP_EVENT_NAME, handleMouseUp);

    return () => {
      document.removeEventListener(MOUSE_MOVE_EVENT_NAME, handleMouseMove);
      document.removeEventListener(MOUSE_UP_EVENT_NAME, handleMouseUp);
    };
  }, [isResizing, minWidth, maxWidth]);

  if (!resizable) {
    return (
      <Drawer {...props} className={MAIN_CLASS_NAME} width={drawerWidth}>
        {children}
      </Drawer>
    );
  }

  const onBarMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsResizing(true);
  };

  return (
    <Drawer {...props} className={MAIN_CLASS_NAME} width={drawerWidth}>
      <div className={RESIZE_BAR_CLASS_NAME} onMouseDown={onBarMouseDown} />
      {children}
    </Drawer>
  );
};

export default ResizableDrawer;
